import React, { Component } from 'react';
import TagSelect from 'components/TagSelect';
import Tag from '../Tag';
import { GeckoRow, GeckoBtn } from 'ui';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import GeckoPermissions from 'services/gecko-permissions';
import { connect } from 'react-redux';

class ConversationTags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addingTag: false,
      tagValues: [],
    };
  }

  handleChange(tags) {
    return GeckoRequest.post('/tags/conversation-tag', {
      conversation_id: this.props.conversation.id,
      tag_id: tags[0],
    })
      .then(() => this.setState({ addingTag: false }))
      .catch((err) => {
        this.setState({ addingTag: false });
        renderError(err);
      });
  }

  addTagHandler() {
    this.setState({ addingTag: true });
  }

  render() {
    const tags = this.props.tags.filter((tag) => {
      return this.props.conversation.tag_ids.indexOf(tag.id) === -1;
    });
    const isAgent = GeckoPermissions.memberOf('agent');
    return (
      <div className="contact-tags-box">
        {!this.props.conversation.tag_ids.length ? (
          <div className="about-tags">
            Tags allow you to more easily find Conversations in the future.
          </div>
        ) : null}
        {this.props.conversation.tag_ids.map((tagId) => {
          const tag = this.props.tags.find((tag) => tag.id === tagId);
          if (!tag) {
            return <React.Fragment />;
          }
          const removeTag = () => {
            GeckoRequest.delete(`/tags/conversation-tag`, {
              conversation_id: this.props.conversation.id,
              tag_id: tag.id,
            }).catch(renderError);
          };
          return <Tag key={tag.id} tag={tag} removeTag={removeTag} />;
        })}
        {this.state.addingTag ? (
          <TagSelect
            value={this.state.tagValues}
            tags={tags}
            onChange={this.handleChange.bind(this)}
            multi={true}
            create={!isAgent}
            placeholder={`Add a ${!isAgent ? 'new' : ''} Tag`}
            config={{
              autoFocus: true,
              openOnFocus: true,
            }}
          />
        ) : (
          <GeckoBtn
            className="tag-button btn-sm"
            name="Add Tag"
            handler={this.addTagHandler.bind(this)}
            icon="far fa-tags"
            type="default"
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tags: state.tags,
  };
};
export default connect(mapStateToProps)(ConversationTags);
